import React from 'react';
import VisitingClinicPage from './VisitingClinicPage';

const VisitingClinicGoldCoast = () => (
  <VisitingClinicPage
    seo={{
      title: 'Autism, ADHD & Learning Assessments Gold Coast | Clinical Minds Psychology',
      description: 'Full neurodevelopmental assessments at regular visiting clinics in Gold Coast: autism, ADHD, FASD and learning disorders, children to adults. First appointment by Zoom, then one visit covers both assessment days. Enquire about upcoming clinic dates.',
      canonicalUrl: 'https://www.clinicalminds.net/visiting-clinics/gold-coast'
    }}
    location="Gold Coast"
    regionPhrase="the Gold Coast and northern NSW"
  />
);

export default VisitingClinicGoldCoast;
